<template>
  <div class="home_container">
    <el-container>
      <el-header>
        <div class="head_box">
          <div class="message_box">
            <i class="el-icon-bell"></i>
            <div class="message" v-show="is_read == 0 ? true : false"></div>
          </div>
          <div class="quite_box" @click="loginOut">
            <div class="quite_title">退出</div>
            <img src="../assets/icon/quite.png" alt="" />
          </div>
        </div>
      </el-header>
      <el-main>
        <div class="user_info" @click="goIndex">
          <img class="user_img" :src="baseUrl + userInfo.avatar" alt="" />
          <div class="user_name">{{ userInfo.nickname }}</div>
          <i class="el-icon-right"></i>
        </div>
        <el-card class="box-card">
          <div slot="header" class="clearfix card_head">
            <img src="@/assets/image/file.png" />
            <div>公告通知</div>
          </div>
          <div
            v-for="(item, index) in noticeList"
            :key="index"
            class="card_noice_item"
          >
            <div class="item_box">
              <div class="card_title">{{ item.title }}</div>
              <div class="card_time">{{ item.createtime }}</div>
            </div>
            <div class="card_txt_box">
              <div :class="contentStatus == index ? '' : 'card_txt'">
                {{ contentStatus == index ? "" : item.content }}
              </div>
              <div
                class="card_txt_info "
                v-if="contentStatus == index"
                v-html="noticeContent"
              ></div>
              <div class="more" @click="more(item, index)">
                {{ contentStatus == index ? "收起" : "查看更多" }}
              </div>
            </div>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix card_head">
            <img src="@/assets/image/action.png" />
            <div>每日文件通知</div>
          </div>
          <div class="card_noice_item">
            <el-table
              :data="dayFileList"
              style="width: 100%"
              :cell-style="cellStayle"
              height="200"
            >
              <el-table-column
                class="table_title"
                fixed
                prop="title"
                label="标题"
                width="600"
              >
              </el-table-column>
              <el-table-column prop="content" label="内容" width="700">
              </el-table-column>
              <el-table-column prop="createtime" label="接收时间">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix card_head">
            <img src="@/assets/image/system.png" />
            <div>系统通知</div>
          </div>
          <div class="card_noice_item">
            <el-table
              :data="systemList"
              style="width: 100%"
              :cell-style="cellStayle"
              height="240"
            >
              <el-table-column
                class="table_title"
                fixed
                prop="title"
                label="标题"
                width="600"
              >
              </el-table-column>
              <el-table-column prop="content" label="内容" width="700">
              </el-table-column>
              <el-table-column prop="createtime" label="接收时间">
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { logout, news_list } from "@/utils/api";
export default {
  data() {
    return {
      userId: "", //所属用户id
      baseUrl: this.$global.commonUrl, //请求地址
      isShowMenu: true, //侧边菜单栏的收缩按钮
      userInfo: null, //用户信息
      contentStatus: -1,
      is_show: -1, //是否展开
      noticeList: [], //消息通知列表
      noticeContent: "", //消息内容
      systemList: [], //系统列表
      dayFileList: [], //每日上传文件列表
      is_read: 0 //消息通知红点  	"is_read": 1,//0-未读 1-已读
    };
  },
  created() {
    this.userId = JSON.parse(localStorage.getItem("userInfo")).id;
    //用户信息
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.getNewsList();
  },

  methods: {
    // 获取公告数据
    getNewsList() {
      var that = this;
      let obj = {
        departmentuser_id: that.userId,
        notice_page: 1,
        notice_page_index: 5,
        system_page: 1,
        system_page_index: 20
      };
      news_list(obj).then(res => {
        if (res.data.code == 1) {
          that.noticeList = res.data.data.notice;
          that.systemList = res.data.data.system;
          that.dayFileList = res.data.data.system_connectionessay;
          that.is_read = res.data.data.is_read;
          sessionStorage.setItem(
            "is_read",
            JSON.stringify(res.data.data.is_read)
          );
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 查看更多
    more(val, index) {
      var that = this;
      that.contentStatus = that.contentStatus == index ? -1 : index;
      var str = val.content;
      str = str.replace(/\n/g, "<br/>");
      that.noticeContent = str;
    },
    // 表格某列的样式
    cellStayle(val) {
      if (val.column.label == "标题") {
        return "font-weight: bold;font-size:15px;color:#000";
      }
    },
    //去首页
    goIndex() {
      var that = this;
      that.$router.push("/index");
      // if (this.$isMobile.isDeviceType()) {
      //   // 移动端
      //   console.log("移动端");
      //   that.$router.push("/indexMobile");
      // } else {
      //   // PC端
      //   that.$router.push("/index");
      //   console.log("PC端");
      // }
    },
    // 用户退出
    loginOut() {
      var that = this;
      that
        .$confirm("确定要退出吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          logout().then(res => {
            if (res.data.code == 1) {
              that.$message.success(res.data.msg);
              localStorage.clear(); // 点击确定后  清除session用户信息
              that.$router.push(`/login`); // 跳转到登录页面
            } else {
              that.$message.error(res.data.msg);
            }
          });
        });
    }
  }
};
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
}
body {
  background: #f5f7fa;
}
.el-header {
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #dce6f8;
}
.head_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.home_container {
  background: #f5f7fa;
}
.quite_box {
  width: 100px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.quite_box img {
  width: 15px;
  height: 15px;
  margin-left: 5px;
}
.el-main {
  color: #333;
  text-align: center;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .user_info {
    width: fit-content !important;
  }
}
.user_info {
  width: 15%;
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 50px;
  padding: 5px;
  margin: 10px;
}
.user_info img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 5px;
}
.user_info i {
  font-size: 25px;
  margin-left: 10px;
  color: #d4d7e0;
}
body > .el-container {
  margin-bottom: 40px;
}
.box-card {
  /* width: 95%; */
  margin: 10px;
  text-align: left;
}

.card_noice_item {
  margin-left: 25px;
  border-bottom: 1px solid #f6f6f9;
}
.item_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.card_title {
  font-size: 16px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #304265;
  margin: 10px 0px;
}
.table_title {
  font-size: 16px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #304265;
}
.card_txt_box {
  width: 90%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.card_txt {
  width: 82%;
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
  margin: 10px 0px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.card_txt_info {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
  margin: 10px 0px;
}
.card_head {
  font-size: 16px;
  font-family: Source Han Sans CN-Bold, Source Han Sans CN;
  font-weight: bold;
  color: #304265;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.card_head img {
  margin-right: 5px;
}
.more {
  width: 300px;
  color: #157df8;
  font-size: 16px;
}
.message_box {
  display: flex;
  flex-direction: row;
}
.message_box i {
  font-size: 20px;
}
.message {
  background: red;
  width: 5px;
  height: 5px;
  border-radius: 50%;
}
.system_title {
  color: red;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/view/Home.vue